import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const BackgroundContainer = styled(Box)(() => ({
  position: 'relative',
  width: '100%',
  height: '37rem',
}));

export const BackgroundImageStyled = styled('img')(() => ({
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  pointerEvents: 'none',
}));

export const BackgroundOverlay = styled(Box)(({ theme }) => ({
  position: 'relative',
  maxWidth: '80rem',
  margin: '0 auto',
  height: '100%',

  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '2rem',

  paddingInline: '1.5rem',
  paddingTop: '6rem',

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 0,
    paddingTop: 0,
  },
}));

export const BackgroundTextWrapper = styled(Box)(({ theme }) => ({
  maxWidth: '30rem',
  textAlign: 'center',
  margin: '0 auto',
  paddingTop: '2.5rem',

  [theme.breakpoints.up('md')]: {
    margin: 0,
    paddingTop: '4.5rem',
  },
}));
